// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgChevronRightFatIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M12.369 12 7.545 7.176a1.86 1.86 0 0 1 2.631-2.631l6.14 6.14a1.86 1.86 0 0 1 0 2.63l-6.14 6.14a1.86 1.86 0 0 1-2.631-2.631z"
    />
  </g>
);
export default SvgChevronRightFatIcon;
SvgChevronRightFatIcon.displayName = 'SvgChevronRightFatIcon';
